




import Vue from 'vue';
import i18n from '@/internationalization/index';
import JSONEditor, { JSONEditorOptions } from 'jsoneditor';

const defaultOptions: JSONEditorOptions = {
    language: i18n.locale
};

export default Vue.extend({
    mounted() {
        this.createEditor();
    },
    props: {
        value: {
            required: true,
            type: Object,
        },
        options: {
            required: false,
            type: Object as () => JSONEditorOptions
        }
    },
    data() {
        return {
            // Has to be null initially because can't create editor
            // without element reference, and the element isn't created
            // until the `mounted` event.
            // Editor is created and assigned in mounted()
            editor: null as unknown as JSONEditor,
            object: this.value
        };
    },
    methods: {
        createEditor() {
            const options: JSONEditorOptions = {
                ...defaultOptions,
                ...this.options,
                onChangeJSON: (updatedObject: object) => {
                    this.object = updatedObject;
                    this.$emit('input', this.object);
                    if (this.options.onChangeJSON) {
                        this.options.onChangeJSON.call(this, updatedObject);
                    }
                },
            };
            this.editor = new JSONEditor(this.$refs.editor as HTMLElement, options);
            this.editor.set(this.object);
        }
    },
    watch: {
        value(newValue) {
            this.object = newValue;
            this.editor.update(newValue);
        }
    },

});
